export default __webpack_public_path__ + "assets/images/f9bd9bb0628391c390719330e38306cc.png";